import * as React from "react";

import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Divider,
	DialogProps,
	useMediaQuery,
	Button,
} from "@material-ui/core";
import {
	useTheme,
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import clsx from "clsx";

export const styles = (theme: Theme) => createStyles({ root: {} });

export type actionStyle = "YesNo" | "ConfirmCancel" | "Alert"

export interface GenericDialogV2Props {
	title: string;
	actionStyle: actionStyle;
	content: React.ReactNode;
	actions?: React.ReactNode;
	className?: WithStyles;
	onConfirm? : () => void;
	onCancel? : () => void;
	onClose?: () => void;
}

const GenericDialogV2 = React.forwardRef<
	HTMLDialogElement,
	GenericDialogV2Props & WithStyles<typeof styles>
>(({ title, content, actionStyle, actions, classes, className, onConfirm, onCancel, onClose }, ref) => {
	const theme = useTheme();
	const [open, setOpen] = React.useState(true);
	const matchXs = useMediaQuery(theme.breakpoints.down("xs"));


	const handleConfirm = () => {
		if (onConfirm) onConfirm();
		setOpen(false);
	}

	const handleCancel = () => {
		if (onCancel) onCancel();
		setOpen(false);
	}

	const handleClose = () => {
		if (onClose) onClose();
		setOpen(false);
	}

	return (
		<Dialog
			open={open}
			ref={ref}
			className={clsx(classes.root, className)}
			fullScreen={matchXs}
		>
			<DialogTitle>{title}</DialogTitle>
			<Divider />
			<DialogContent>{content}</DialogContent>
			<Divider />
			<DialogActions>{actions}
				{
					actionStyle != "Alert" && 
					<Button
						onClick={handleConfirm}
						variant="contained"
						color="primary"
					>
						Yes
					</Button>
				}
				{

				}

				{ (actionStyle == "Alert" || actionStyle == "YesNo") &&
					<Button
					onClick={handleClose}
						color="primary"
					>
						Close
					</Button>
				}


			</DialogActions>
		</Dialog>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("GenericDialog"),
})(GenericDialogV2);
